export default __webpack_public_path__ + "bc1776fc24549d2f872098d3d733535b.png";